
import { Component, Prop, h } from '@stencil/core';
import { Color } from '../../interface';

@Component({
  tag: 'lar-weather-item',
  shadow: false,
  scoped: false,
})
export class WeatherItem {
  /**
   * Component JSON text
   */
  @Prop() icon: string;
  @Prop() name: string;
  @Prop() value: string;
  @Prop() rotateIcon?: number;

  render() {
    return [
      <lar-list-item>
        <div slot="start" class="circle">
          <lar-icon color="tertiary" style={{ transform: `rotate(${this.rotateIcon || 0}deg)` }} icon={this.icon} />
        </div>
        <h4><lar-translate t={this.name} /></h4>
        {this.value !== 'true' && this.value !== 'false' && <span>{this.value}</span>}
        {(this.value === 'true' || this.value === 'false') && <span><lar-translate t={`weather.${this.value}`} /></span>}
      </lar-list-item>
    ];
  }
}